import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../base/i18n/functions';
import Label from '../../base/label/components/web/Label';
// eslint-disable-next-line lines-around-comment
// @ts-ignore
import { Tooltip } from '../../base/tooltip';
import { _mapStateToProps } from './AbstractTranscribingLabel';
const TranscribingLabel = ({ _showLabel, t }) => {
    if (!_showLabel) {
        return null;
    }
    return (React.createElement(Tooltip, { content: t('transcribing.labelToolTip'), position: 'left' },
        React.createElement(Label, { className: 'recording-label', text: t('transcribing.tr') })));
};
export default translate(connect(_mapStateToProps)(TranscribingLabel));
